import React, { useState, useRef, useCallback, useEffect } from 'react';
import { useMap, useMapEvents } from 'react-leaflet';
import L, { LatLngExpression } from 'leaflet';
import { MapBounds } from '../../../types/map';

// Fix leaflet default icon paths
delete (L.Icon.Default.prototype as any)._getIconUrl;
L.Icon.Default.mergeOptions({
  iconRetinaUrl:
    'https://cdnjs.cloudflare.com/ajax/libs/leaflet/1.9.4/images/marker-icon-2x.png',
  iconUrl:
    'https://cdnjs.cloudflare.com/ajax/libs/leaflet/1.9.4/images/marker-icon.png',
  shadowUrl:
    'https://cdnjs.cloudflare.com/ajax/libs/leaflet/1.9.4/images/marker-shadow.png',
});

interface MapEventsHandlerProps {
  animatePanning?: boolean;
  setMapViewPort: React.Dispatch<
    React.SetStateAction<{
      center: LatLngExpression;
      zoom: number;
      bounds: MapBounds | null;
    }>
  >;
  refetchByGeo?: () => void;
  handleSelectMarker?: (id: string) => void;
}

// Component to handle map events and viewport changes
export const MapEventsHandler: React.FC<MapEventsHandlerProps> = ({
  animatePanning = false,
  setMapViewPort,
  refetchByGeo,
  handleSelectMarker,
}) => {
  const map = useMap();
  const debounceTimerRef = useRef<NodeJS.Timeout | null>(null);
  // const [zoom, setZoom] = useState<number>(map.getZoom());
  // const [bounds, setBounds] = useState<LatLngBoundsExpression>(map.getBounds());

  // Debounced refetch function with 700ms delay
  const debouncedRefetchByGeo = useCallback(() => {
    if (debounceTimerRef.current) {
      clearTimeout(debounceTimerRef.current);
    }

    debounceTimerRef.current = setTimeout(() => {
      refetchByGeo?.();
    }, 700);
  }, [refetchByGeo]);

  // Cleanup timer on unmount
  useEffect(() => {
    return () => {
      if (debounceTimerRef.current) {
        clearTimeout(debounceTimerRef.current);
      }
    };
  }, []);

  function handleViewportChange() {
    const { lat, lng } = map.getCenter();
    const zoom = map.getZoom();
    const bounds = map.getBounds();
    setMapViewPort({
      center: [Number(lat.toFixed(3)), Number(lng.toFixed(3))],
      zoom,
      bounds: {
        north: bounds.getNorth(),
        south: bounds.getSouth(),
        east: bounds.getEast(),
        west: bounds.getWest(),
      },
    });
  }

  useMapEvents({
    load: () => {
      handleViewportChange();
      // debouncedRefetchByGeo();
    },
    click: (e) => {
      map.setView(e.latlng, map.getZoom(), {
        animate: animatePanning,
      });
    },
    dragend: () => {
      handleSelectMarker?.('');
      handleViewportChange();
      debouncedRefetchByGeo();
    },
    moveend: () => {
      handleViewportChange();
    },
    zoomend: () => {
      handleViewportChange();
    },
    // // this messes with the cluster
    // layeradd: () => {
    //   let bounds = new L.LatLngBounds([]);
    //   map.eachLayer(function (layer) {
    //     if (layer instanceof L.FeatureGroup) {
    //       bounds.extend(layer.getBounds());
    //     }
    //   });

    //   if (bounds.isValid()) {
    //     map.fitBounds(bounds);
    //   }
    // },
    // overlayadd: () => {
    //   let bounds = new L.LatLngBounds([]);
    //   map.eachLayer(function (layer) {
    //     if (layer instanceof L.FeatureGroup) {
    //       bounds.extend(layer.getBounds());
    //     }
    //   });

    //   if (bounds.isValid()) {
    //     map.flyToBounds(bounds);
    //   }
    // },
  });

  return null;
};
